import * as React from 'react';
import * as Utils from '../Utils';

export interface IClockOptionsProps {
  addEnabled: boolean;
  onCancel(): void;
  onAdd(additionalDuration: number): void;
}

const DURATIONS = [30_000, 60_000, 180_000, 300_000, 600_000]

export default class ClockOptions extends React.Component<IClockOptionsProps> {

  constructor(props: IClockOptionsProps) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }
  public render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary btn-lg m-2"
          onClick={this.props.onCancel}
        >
          Cancel
        </button>
        {this.props.addEnabled ?
          DURATIONS.map(dur => {
            return this.button(Utils.getLabel(dur), dur)
          })
          :
          null
        }
      </div>
    );
  }

  private button(label: string, durationMs: number) {
    return (
      <button
        type="button"
        key={durationMs}
        className="btn btn-primary btn-lg m-2"
        data-duration={durationMs}
        onClick={this.onClick}
      >
        +{label}
      </button>
    )
  }

  private onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    const durationMs = event.currentTarget.getAttribute("data-duration");
    if (durationMs) {
      this.props.onAdd(parseInt(durationMs, 10))
    }
  }
}



// WEBPACK FOOTER //
// ./src/Timer/ClockOptions.tsx